import React, { createContext, useContext, useState } from "react";
import ChatAgent from "@components/ChatAgent";

interface ChatAgentContextType {
  isOpen: boolean;
  sessionId: string;
  corporateId: string;
  openChat: (corporateId: string) => void;
  closeChat: () => void;
}

const ChatAgentContext = createContext<ChatAgentContextType | undefined>(
  undefined,
);

export const useChatAgent = (): ChatAgentContextType => {
  const context = useContext(ChatAgentContext);
  if (!context) {
    throw new Error(
      "useChatAgent deve essere usato all'interno di un ChatAgentProvider",
    );
  }
  return context;
};

export const ChatAgentProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [sessionId, setSessionId] = useState("");
  const [corporateId, setCorporateId] = useState("");

  const openChat = (corporateId: string) => {
    setIsOpen(true);
    if (!sessionId) setSessionId(crypto.randomUUID());
    setCorporateId(corporateId);
  };

  const closeChat = () => {
    setIsOpen(false);
  };

  return (
    <ChatAgentContext.Provider
      value={{ isOpen, sessionId, corporateId, openChat, closeChat }}
    >
      {children}
      <ChatAgent />
    </ChatAgentContext.Provider>
  );
};
